
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import InvitationManager from './InvitationManager';

interface InvitationModalProps {
  isOpen: boolean;
  onClose: () => void;
  userType: 'school' | 'coach';
}

const InvitationModal: React.FC<InvitationModalProps> = ({
  isOpen,
  onClose,
  userType,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <InvitationManager userType={userType} />
      </DialogContent>
    </Dialog>
  );
};

export default InvitationModal;
